import { useEffect } from "react";
import { useNavigate, useSearchParams, useLocation } from "react-router-dom";

export default function RedirectPage() {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const location = useLocation();

  useEffect(() => {
    const bookingId = searchParams.get("b");

    if (!bookingId) {
      // If no booking ID, redirect to home
      navigate("/", { replace: true });
      return;
    }

    // Determine redirect path based on current pathname
    let redirectPath = "/";

    if (location.pathname.includes("redirect-guests")) {
      redirectPath = `/guests/${bookingId}`;
    } else if (location.pathname.includes("redirect-expected")) {
      redirectPath = `/expected/${bookingId}`;
    } else if (location.pathname.includes("redirect-messages")) {
      redirectPath = `/guests/${bookingId}/messages`;
    }

    navigate(redirectPath, { replace: true });
  }, [searchParams, navigate, location.pathname]);

  // Return null or a loading indicator
  return null;
}
